"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var TimeSelector = function (_a) {
    var schedule = _a.schedule, type = _a.type, onTimeChange = _a.onTimeChange;
    var initialTime = type === "start" ? schedule.start : schedule.end;
    var _b = (0, react_1.useState)(initialTime || "00:00"), selectedTime = _b[0], setSelectedTime = _b[1];
    var _c = (0, react_1.useState)(initialTime || "00:00"), lastValidTime = _c[0], setLastValidTime = _c[1];
    var _d = (0, react_1.useState)(null), anchorEl = _d[0], setAnchorEl = _d[1];
    var menuItemRefs = (0, react_1.useRef)([]);
    var map = (0, react_1.useRef)(new Map());
    var nodeRef = (0, react_1.useRef)(null);
    var open = Boolean(anchorEl);
    var id = open ? "time-selector-popover" : undefined;
    (0, react_1.useEffect)(function () {
        if (nodeRef.current) {
            map.current.set(schedule.id, nodeRef.current);
        }
        else {
            map.current.delete(schedule.id);
        }
        return function () {
            map.current.delete(schedule.id);
        };
    }, [nodeRef, schedule.id]);
    (0, react_1.useEffect)(function () {
        if (open && selectedTime) {
            var hourIndex = parseInt(selectedTime.split(":")[0], 10);
            var ref = menuItemRefs.current[hourIndex];
            if (ref) {
                ref.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }
    }, [open, selectedTime]);
    var handleSelect = function (time) {
        setSelectedTime(time);
        setLastValidTime(time);
        onTimeChange(schedule.id, type, time);
        setAnchorEl(null);
    };
    var handleInputChange = function (event) {
        var value = event.target.value;
        setSelectedTime(value);
        onTimeChange(schedule.id, type, value);
    };
    var handleBlur = function (event) {
        var value = event.target.value;
        var _a = value.split(":").map(Number), hours = _a[0], minutes = _a[1];
        if (Number.isNaN(hours) ||
            Number.isNaN(minutes) ||
            hours < 0 ||
            hours > 23 ||
            minutes < 0 ||
            minutes > 59) {
            setSelectedTime(lastValidTime);
        }
        else {
            setLastValidTime(value);
            onTimeChange(schedule.id, type, value);
        }
    };
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
        setTimeout(function () {
            if (selectedTime) {
                var hourIndex = parseInt(selectedTime.split(":")[0], 10);
                var ref = menuItemRefs.current[hourIndex];
                if (ref) {
                    ref.scrollIntoView({ behavior: "smooth", block: "center" });
                }
            }
        }, 0);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(material_1.FormControl, { variant: "outlined", ref: nodeRef, "data-cy": "time-selector-".concat(type) },
        react_1.default.createElement(q_play_components_1.Input, { value: selectedTime, onChange: handleInputChange, onBlur: handleBlur, onClick: handleClick, placeholder: "HH:MM", style: {
                width: "82px",
                height: "34px",
                fontSize: "15px",
                padding: "0px 20px 0 23px",
                color: "var(--info-color)",
                fontFamily: "Geomanist",
                borderRadius: "4px"
            }, "data-cy": "time-input-".concat(type) }),
        react_1.default.createElement(material_1.Popover, { id: id, open: open, anchorEl: anchorEl, onClose: handleClose, anchorOrigin: {
                vertical: "bottom",
                horizontal: "left",
            }, transformOrigin: {
                vertical: "top",
                horizontal: "left",
            }, slotProps: {
                paper: {
                    style: {
                        width: 78,
                        maxHeight: 250,
                        top: 597,
                        left: 593,
                        paddingLeft: 6
                    },
                }
            }, disableAutoFocus: true, disableEnforceFocus: true }, Array.from({ length: 24 }, function (_, i) {
            var time = "".concat(i).padStart(2, "0") + ":00";
            return (react_1.default.createElement(material_1.MenuItem, { key: time, ref: function (el) { return menuItemRefs.current[i] = el; }, onClick: function () { return handleSelect(time); }, style: { fontSize: "14px", padding: "5px", height: "34px", color: "var(--info-color)", fontFamily: "Geomanist" }, "data-cy": "time-item-".concat(time) },
                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: free_solid_svg_icons_1.faAngleRight, style: { marginRight: "5px", color: "var(--primary-color)" } }),
                time));
        }))));
};
exports.default = TimeSelector;
